import { render } from "./MktTags.vue?vue&type=template&id=02e19cea&scoped=true"
import script from "./MktTags.vue?vue&type=script&lang=js"
export * from "./MktTags.vue?vue&type=script&lang=js"

import "./MktTags.vue?vue&type=style&index=0&id=02e19cea&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e19cea"]])

export default __exports__